
import { combineReducers } from 'redux';
import { curationFee } from "./curation-fee/curationFee.reducer"
import { dealMonitoring } from './deal-monitoring/dealMonitoring.reducer';

export const mediagrid = combineReducers({
    dealMonitoring,
    curationFee
});
